import { SupportCostsStore, NewSupportCostStore, ChangeSupportCostStore, ChangeLogSupportCostStore } from './support-costs-store';

export function setupRepositories(storeBuilder) {
  storeBuilder.addRepository(new SupportCostsStore());
  storeBuilder.addRepository(new NewSupportCostStore());
  storeBuilder.addRepository(new ChangeSupportCostStore());
  storeBuilder.addRepository(new ChangeLogSupportCostStore());
}
